<template>
  <div id="UserInfo" :class="{ 'user-info-estelam': NeedEstelam == 'true' }">
    <loading v-if="loadingRender"></loading>
    <div v-if="!NeedEstelam" class="no-print">
      <panel
        Title="تغییر رمز عبور"
        Des="از طریق این فرم می‌توانید رمز عبور اینترنت بانک خود را تغییر دهید"
        :IsBtnBack="true"
        ClassCustom="bg-dark-Custom text-right mt-2"
      ></panel>
      <div class="row px-3">
        <div class="col-12 col-md-12 mx-md-2 p-md-3">
          <net-pa-card>
            <template slot="header">
              <h6 class="text-right">
                <i class="fas fa-key"></i>
                تغییر رمز عبور
              </h6>
            </template>
            <template slot="content">
              <div class="user-info-change-pass-content">
                <div
                  class="user-info-change-pass-alert alert alert-warning border-warning"
                >
                  <span class="badge badge-warning mb-2 p-1">هشدار امنیتی</span>
                  <ul class="user-info-change-pass-alert__list mb-0">
                    <li>
                      جهت جلوگیری از سوء استفاده، رمز اینترنت بانک خود را هر چند
                      مدت یکبار تعویض نمایید.
                    </li>
                    <li>
                      برای امنیت بیشتر بهتر است رمز اینترنت بانک شما شامل حروف
                      بزرگ و کوچک انگلیسی و اعداد باشد.
                    </li>
                  </ul>
                </div>

                <form id="divpass" class="user-info-change-pass-form">
                  <div class="user-info-change-pass-field">
                    <input
                      type="password"
                      v-model="oldpass"
                      @keypress="$BlockSuspiciousInput($event, 30)"
                      @keyup="$BlockSuspiciousInput($event, 30)"
                      class="form-control text-center"
                      :class="NeedEstelam === 'true' ? '' : 'required'"
                      placeholder="رمز عبور فعلی"
                      autocomplete="off"
                    />
                  </div>
                  <div class="user-info-change-pass-field">
                    <input
                      type="password"
                      @keypress="$BlockSuspiciousInput($event, 30)"
                      @keyup="$BlockSuspiciousInput($event, 30)"
                      v-model="newpass"
                      class="form-control text-center"
                      :class="
                        NeedEstelam === 'true' ? '' : 'required required-Pass'
                      "
                      placeholder="رمز جدید"
                      autocomplete="new-password"
                    />
                  </div>
                  <div class="user-info-change-pass-field">
                    <input
                      type="password"
                      @keypress="$BlockSuspiciousInput($event, 30)"
                      @keyup="$BlockSuspiciousInput($event, 30)"
                      v-model="newpasscomfirm"
                      class="form-control text-center"
                      :class="
                        NeedEstelam === 'true' ? '' : 'required required-Pass'
                      "
                      placeholder="تکرار رمز جدید"
                      autocomplete="new-password"
                    />
                  </div>
                  <div class="user-info-change-pass-actions">
                    <button
                      type="button"
                      class="btn btn-success user-info-change-pass-submit-btn"
                      @click.prevent="ChangePass($event)"
                    >
                      تغییر رمز
                    </button>
                  </div>
                </form>
              </div>
            </template>
          </net-pa-card>
        </div>
      </div>
    </div>
    <div class="no-print" :class="{ 'user-info-estelam-shell': NeedEstelam == 'true' }">
      <panel
        Title="اطلاعات هویتی"
        Des="اطلاعات شما در این بخش قابل مشاهده است"
        :IsBtnBack="NeedEstelam == 'true'"
        ClassCustom="bg-dark-Custom text-right mt-2"
      ></panel>
      <div class="row px-3">
        <div class="col-12 col-md-12 mx-md-2 p-md-3">
          <div
            v-if="NeedEstelam == 'true'"
            class="user-info-identity-alert"
          >
            <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
            <p>
              کاربر گرامی، اطلاعات هویتی شما ناقص است. لطفا موارد خواسته‌شده را
              تکمیل کنید.
            </p>
          </div>
          <net-pa-card v-if="EstlamSuccess == false && NeedEstelam == 'true'">
            <template slot="header">
              <h6 class="text-right">
                <i class="fas fa-user-shield"></i> احراز هویت
              </h6>
            </template>
            <template slot="content">
              <div class="user-info-auth">
                <p class="user-info-auth-hint">
                  برای دریافت کد، شماره موبایل و تاریخ تولد باید با اطلاعات واقعی شما مطابقت داشته باشد.
                </p>
                <form
                  v-if="stage == 1"
                  :id="'stage' + stage"
                  class="user-info-auth-form"
                  @submit.prevent
                >
                  <div class="user-info-auth-field">
                    <label for="EstelamCodeMeli">کد ملی</label>
                    <input
                      id="EstelamCodeMeli"
                      class="form-control text-center required user-info-auth-input"
                      disabled
                      v-model="DataAxiosEstelamSabtAhval.CodeMeli"
                      type="number"
                      placeholder="کد ملی"
                      autocomplete="off"
                      @keypress="
                        $ValidNumber($event, 10);
                        $BlockSuspiciousInput($event, 10);
                      "
                    />
                  </div>
                  <div class="user-info-auth-grid">
                    <div class="user-info-auth-field">
                      <label for="Mobile">شماره موبایل</label>
                      <input
                        class="form-control text-center required user-info-auth-input"
                        type="text"
                        id="Mobile"
                        name="Mobile"
                        placeholder="شماره موبایل"
                        autocomplete="off"
                        v-model="DataAxiosEstelamSabtAhval.Mobile"
                        @keypress="
                          $ValidNumber($event, 11);
                          $BlockSuspiciousInput($event, 11);
                        "
                      />
                    </div>
                    <div class="user-info-auth-field user-info-auth-field--date">
                      <label>تاریخ تولد</label>
                      <date-picker
                        input-class="required"
                        :editable="true"
                        color="#05b8c8"
                        autocomplete="off"
                        placeholder="تاریخ تولد"
                        v-model="DataAxiosEstelamSabtAhval.BirthDate"
                      ></date-picker>
                    </div>
                  </div>
                  <div class="user-info-auth-actions">
                    <button
                      type="button"
                      class="user-info-auth-submit"
                      @click.prevent="sendSms('stage' + stage)"
                    >
                      ارسال کد احراز هویت
                    </button>
                  </div>
                </form>
                <form
                  v-if="stage == 2"
                  :id="'stage' + stage"
                  class="user-info-auth-form"
                  @submit.prevent
                >
                  <div class="user-info-auth-field">
                    <label for="EstelamOtp">کد احراز هویت پیامک‌شده</label>
                    <input
                      id="EstelamOtp"
                      class="form-control text-center required user-info-auth-input"
                      placeholder="کد احراز هویت"
                      type="number"
                      @keypress="$ValidNumber($event, 10)"
                      v-model="randomKey"
                    />
                  </div>
                  <div class="user-info-auth-actions">
                    <button
                      type="button"
                      class="user-info-auth-submit"
                      @click.prevent="OkCode('stage' + stage)"
                    >
                      تایید کد پیامکی
                    </button>
                  </div>
                </form>
              </div>
            </template>
          </net-pa-card>

          <net-pa-tab
            v-if="UserTabs.length > 0"
            :Tabs="UserTabs"
            @change="onTabChange"
          ></net-pa-tab>
          <div class="tab-content" id="nav-tabContent">
            <div
              class="tab-pane fade show active"
              id="nav-home"
              v-if="showTab(0)"
              role="tabpanel"
              aria-labelledby="nav-home-tab"
            >
              <net-pa-card :Compact="true">
                <template slot="content">
                  <div class="user-info-identity" id="userInfoDiv">
                    <div class="user-info-identity-hero">
                      <img
                        :src="avatarSrc"
                        alt="تصویر پروفایل"
                        class="user-info-avatar"
                      />
                      <div class="user-info-identity-hero__meta">
                        <h6 class="user-info-identity-hero__name">
                          {{ UserInfo.ozvName }} {{ UserInfo.ozvFamily }}
                        </h6>
                        <p
                          v-if="UserInfo.shomareOzv"
                          class="user-info-identity-hero__id"
                        >
                          شماره عضویت {{ UserInfo.shomareOzv }}
                        </p>
                        <div
                          v-if="
                            $session.get('UserInfoNetPa').isEstelamSabtAhval ==
                              true && IsrequiredEstelamSabtAhval == 'true'
                          "
                          class="user-info-identity-verified"
                        >
                          <i class="fas fa-user-shield" aria-hidden="true"></i>
                          <div>
                            <strong>احراز هویت شده</strong>
                            <span
                              >اطلاعات هویتی شما توسط سامانه ثبت احوال تایید شده
                              است</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>

                    <section class="user-info-identity-section">
                      <h6 class="user-info-identity-section__title">
                        <i class="fas fa-id-card" aria-hidden="true"></i>
                        اطلاعات فردی
                      </h6>
                      <div class="user-info-identity-fields">
                        <label
                          class="user-info-identity-field user-info-identity-field--sm"
                        >
                          <span class="user-info-identity-label">نام</span>
                          <input
                            type="text"
                            :disabled="
                              !canChange.canChangeOzvName || FixInput == true
                            "
                            class="form-control"
                            placeholder="نام"
                            v-model="UserInfo.ozvName"
                            @keypress="$BlockSuspiciousInput($event, 30)"
                          />
                        </label>
                        <label
                          class="user-info-identity-field user-info-identity-field--md"
                        >
                          <span class="user-info-identity-label"
                            >نام خانوادگی</span
                          >
                          <input
                            type="text"
                            :disabled="
                              !canChange.canChangeOzvFamily || FixInput == true
                            "
                            class="form-control text-right"
                            placeholder="نام خانوادگی"
                            v-model="UserInfo.ozvFamily"
                            @keypress="$BlockSuspiciousInput($event, 40)"
                          />
                        </label>
                        <label
                          class="user-info-identity-field user-info-identity-field--sm"
                        >
                          <span class="user-info-identity-label">کد ملی</span>
                          <input
                            type="text"
                            :disabled="
                              !canChange.canChangeCodeMeli || FixInput == true
                            "
                            class="form-control text-left required-CodeMeli"
                            placeholder="کد ملی"
                            v-model="UserInfo.codeMeli"
                            @keypress="$BlockSuspiciousInput($event, 10)"
                          />
                        </label>
                        <label
                          class="user-info-identity-field user-info-identity-field--md"
                        >
                          <span class="user-info-identity-label"
                            >شماره عضویت</span
                          >
                          <input
                            type="text"
                            disabled
                            class="form-control text-left"
                            placeholder="شماره مشتری"
                            v-model="UserInfo.shomareOzv"
                            @keypress="$BlockSuspiciousInput($event, 30)"
                          />
                        </label>
                        <label
                          class="user-info-identity-field user-info-identity-field--sm"
                        >
                          <span class="user-info-identity-label">نام پدر</span>
                          <input
                            type="text"
                            class="form-control"
                            :disabled="
                              !canChange.canChangePedar || FixInput == true
                            "
                            placeholder="نام پدر"
                            v-model="UserInfo.pedar"
                            @keypress="$BlockSuspiciousInput($event, 20)"
                          />
                        </label>
                        <label
                          class="user-info-identity-field user-info-identity-field--sm"
                        >
                          <span class="user-info-identity-label"
                            >شماره شناسنامه</span
                          >
                          <input
                            type="text"
                            class="form-control text-left required"
                            :disabled="!canChange.canChangeShenasname"
                            placeholder="شماره شناسنامه"
                            v-model="UserInfo.shenasname"
                            @keypress="$BlockSuspiciousInput($event, 15)"
                          />
                        </label>
                        <div
                          class="user-info-identity-field user-info-identity-field--md"
                        >
                          <span class="user-info-identity-label"
                            >تاریخ تولد</span
                          >
                          <date-picker
                            :editable="true"
                            :disabled="
                              !canChange.canChangeBirthDate || FixInput == true
                            "
                            :auto-submit="true"
                            color="#287db4"
                            v-model="UserInfo.birthDate"
                          ></date-picker>
                          <input
                            type="text text-left"
                            :disabled="
                              !canChange.canChangeBirthDate || FixInput == true
                            "
                            tabindex="-1"
                            class="d-none InputText"
                            style="direction: ltr"
                          />
                        </div>
                      </div>
                    </section>

                    <section class="user-info-identity-section">
                      <h6 class="user-info-identity-section__title">
                        <i class="fas fa-address-book" aria-hidden="true"></i>
                        تماس و نشانی
                      </h6>
                      <div class="user-info-identity-fields">
                        <label
                          class="user-info-identity-field user-info-identity-field--sm"
                        >
                          <span class="user-info-identity-label"
                            >شماره همراه</span
                          >
                          <input
                            type="text"
                            :disabled="
                              !canChange.canChangeMobile || FixInput == true
                            "
                            class="form-control text-left"
                            placeholder="شماره همراه"
                            v-model="UserInfo.mobile"
                            @keypress="$BlockSuspiciousInput($event, 11)"
                          />
                        </label>
                        <label
                          class="user-info-identity-field user-info-identity-field--sm"
                        >
                          <span class="user-info-identity-label">تلفن</span>
                          <input
                            type="text"
                            :disabled="!canChange.canChangeTel"
                            class="form-control text-left"
                            placeholder="تلفن ثابت"
                            v-model="UserInfo.tel"
                            @keypress="$BlockSuspiciousInput($event, 15)"
                          />
                        </label>
                        <label
                          class="user-info-identity-field user-info-identity-field--lg"
                        >
                          <span class="user-info-identity-label"
                            >آدرس ایمیل</span
                          >
                          <input
                            type="text"
                            class="form-control text-left"
                            dir="ltr"
                            :disabled="!canChange.canChangeEmail"
                            placeholder="ایمیل"
                            v-model="UserInfo.email"
                            @keypress="$BlockSuspiciousInput($event, 40)"
                          />
                        </label>
                        <label
                          class="user-info-identity-field user-info-identity-field--wide"
                        >
                          <span class="user-info-identity-label">آدرس</span>
                          <input
                            type="text"
                            class="form-control"
                            placeholder="آدرس"
                            :disabled="!canChange.canChangeAdres"
                            v-model="UserInfo.adres"
                            @keypress="$BlockSuspiciousInput($event, 300)"
                          />
                        </label>
                      </div>
                    </section>

                    <section
                      v-if="$session.get('CustCode') != '932'"
                      class="user-info-identity-section"
                    >
                      <h6 class="user-info-identity-section__title">
                        <i class="fas fa-briefcase" aria-hidden="true"></i>
                        اطلاعات شغلی و سازمانی
                      </h6>
                      <div class="user-info-identity-fields">
                        <label
                          class="user-info-identity-field user-info-identity-field--md"
                        >
                          <span class="user-info-identity-label"
                            >سال ورود به سازمان</span
                          >
                          <input
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder="سال ورود"
                            v-model="UserInfo.tarixEmp"
                          />
                        </label>
                        <label
                          class="user-info-identity-field user-info-identity-field--md"
                        >
                          <span class="user-info-identity-label"
                            >رسته خدمت</span
                          >
                          <input
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder="رسته خدمت"
                          />
                        </label>
                        <label
                          class="user-info-identity-field user-info-identity-field--md"
                        >
                          <span class="user-info-identity-label"
                            >مدرک تحصیلی</span
                          >
                          <input
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder="مدرک تحصیلی"
                            v-model="UserInfo.tblComboIdTahsilat316"
                          />
                        </label>
                        <label
                          class="user-info-identity-field user-info-identity-field--lg"
                        >
                          <span class="user-info-identity-label">محل کار</span>
                          <input
                            type="text"
                            :disabled="$session.get('CustCode') != 886"
                            class="form-control"
                            placeholder="محل کار"
                            v-model="UserInfo.mahalKar"
                          />
                        </label>
                        <label
                          class="user-info-identity-field user-info-identity-field--md"
                        >
                          <span class="user-info-identity-label"
                            >سنوات خدمت (سال-ماه)</span
                          >
                          <input
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder="سنوات"
                            :value="
                              (UserInfo.sanavatSal == null
                                ? 0
                                : UserInfo.sanavatSal) +
                              '-' +
                              (UserInfo.sanavatMah == null
                                ? 0
                                : UserInfo.sanavatMah)
                            "
                          />
                        </label>
                        <div
                          class="user-info-identity-field user-info-identity-field--md"
                        >
                          <span class="user-info-identity-label"
                            >نوع اشتغال</span
                          >
                          <SelectCombo
                            @result="getSelectedCombo"
                            :grp="24"
                            :defaultItemId="UserInfo.comboIdNoeEstekhdam33"
                            :disabled="FixInput == true"
                          ></SelectCombo>
                        </div>
                        <label
                          class="user-info-identity-field user-info-identity-field--md"
                        >
                          <span class="user-info-identity-label"
                            >شهر محل خدمت</span
                          >
                          <input
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder="شهر محل خدمت"
                            v-model="UserInfo.tblComboIdGrp11WorkCity"
                          />
                        </label>
                        <label
                          class="user-info-identity-field user-info-identity-field--sm"
                        >
                          <span class="user-info-identity-label">محل تولد</span>
                          <input
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder="محل تولد"
                            v-model="UserInfo.mahalSodor"
                          />
                        </label>
                        <label
                          class="user-info-identity-field user-info-identity-field--md"
                        >
                          <span class="user-info-identity-label"
                            >رسته سازمانی</span
                          >
                          <input
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder="رسته سازمانی"
                            v-model="UserInfo.rasteSazmani"
                          />
                        </label>
                        <label
                          class="user-info-identity-field user-info-identity-field--lg"
                        >
                          <span class="user-info-identity-label"
                            >پست سازمانی</span
                          >
                          <input
                            type="text"
                            :disabled="$session.get('CustCode') != 886"
                            class="form-control"
                            placeholder="پست سازمانی"
                            v-model="UserInfo.postSazmani"
                            autocomplete="off"
                          />
                        </label>
                      </div>
                    </section>

                    <div
                      v-if="$session.get('UserInfoNetPa').cId != '801'"
                      class="user-info-identity-footer"
                    >
                      <button
                        type="button"
                        class="sv-btn sv-btn--primary sv-btn--wide"
                        @click="UpdateUser()"
                      >
                        ثبت تغییرات
                      </button>
                    </div>
                  </div>
                </template>
              </net-pa-card>
            </div>
            <div
              class="tab-pane fade"
              id="nav-BankAccount"
              role="tabpanel"
              aria-labelledby="nav-BankAccount-tab"
            >
              <net-pa-card :Compact="true">
                <template slot="content">
                  <div
                    v-if="addBankAccount == false"
                    class="user-info-bank-list"
                    dir="rtl"
                  >
                    <div class="user-info-bank-list__toolbar">
                      <button
                        type="button"
                        class="user-info-bank-chip user-info-bank-chip--add"
                        @click="addBankAccount = true"
                      >
                        <i class="fas fa-plus" aria-hidden="true"></i>
                        اضافه کردن حساب بانکی
                      </button>
                    </div>
                    <p v-if="!rows.length" class="user-info-status-empty">
                      موردی برای نمایش وجود ندارد
                    </p>
                    <div v-else class="user-info-bank-list__cards">
                      <article
                        v-for="(row, index) in rows"
                        :key="(row.id || 'bank') + '-' + index"
                        class="user-info-bank-card"
                      >
                        <div class="user-info-bank-card__header">
                          <strong class="user-info-bank-card__name">{{
                            row.nameSahebHesab || "حساب بانکی"
                          }}</strong>
                          <span
                            v-if="row.bankName"
                            class="user-info-bank-card__badge"
                            >{{ row.bankName }}</span
                          >
                        </div>
                        <div class="user-info-bank-card__fields">
                          <div class="user-info-bank-card__field">
                            <span>شماره حساب</span>
                            <strong dir="ltr">{{ row.hesabNo || "—" }}</strong>
                          </div>
                          <div class="user-info-bank-card__field">
                            <span>شماره کارت</span>
                            <strong dir="ltr">{{ row.cardNo || "—" }}</strong>
                          </div>
                          <div class="user-info-bank-card__field">
                            <span>شماره شبا</span>
                            <strong dir="ltr">{{ row.shebaNo || "—" }}</strong>
                          </div>
                        </div>
                        <div class="user-info-bank-card__actions">
                          <button
                            type="button"
                            class="user-info-bank-chip user-info-bank-chip--edit"
                            @click="GEtAzaHesab(row.id)"
                          >
                            <i class="fa fa-edit" aria-hidden="true"></i>
                            ویرایش
                          </button>
                        </div>
                      </article>
                    </div>
                  </div>

                  <div v-else class="user-info-identity user-info-bank-add">
                    <div
                      class="user-info-identity-fields user-info-bank-form"
                      id="addAccountBank"
                    >
                      <div
                        class="user-info-identity-field user-info-identity-field--md"
                        v-if="$session.get('CustCode') != '932'"
                      >
                        <span class="user-info-identity-label">شماره شبا</span>
                        <div class="user-info-sheba-input">
                          <span class="user-info-sheba-prefix">IR</span>
                          <input
                            type="text"
                            class="form-control required"
                            dir="ltr"
                            @keypress="
                              $ValidNumber($event, 24);
                              $BlockSuspiciousInput($event, 24);
                            "
                            @keydown="$BlockSuspiciousInput($event, 24)"
                            v-model="bankAcoount.ShebaNo"
                            autocomplete="off"
                          />
                        </div>
                      </div>

                      <div
                        class="user-info-identity-field user-info-identity-field--md"
                      >
                        <span class="user-info-identity-label"
                          >نام صاحب حساب</span
                        >
                        <input
                          type="text"
                          class="form-control required"
                          v-model="bankAcoount.NameSahebHesab"
                          :disabled="FixInput"
                          @keypress="$BlockSuspiciousInput($event, 20)"
                        />
                      </div>
                      <div
                        class="user-info-identity-field user-info-identity-field--md"
                        v-if="
                          $session.get('CustCode') != '932' &&
                          $session.get('CustCode') != 948
                        "
                      >
                        <span class="user-info-identity-label">شماره کارت</span>
                        <input
                          type="text"
                          class="form-control required"
                          dir="ltr"
                          @keypress="
                            $ValidNumber($event, 16);
                            $BlockSuspiciousInput($event, 16);
                          "
                          @keydown="$BlockSuspiciousInput($event, 16)"
                          v-model="bankAcoount.CardNo"
                        />
                      </div>
                      <div
                        class="user-info-identity-field user-info-identity-field--md"
                        v-if="$session.get('CustCode') != 948"
                      >
                        <span class="user-info-identity-label">شماره حساب</span>
                        <input
                          v-if="$session.get('CustCode') != 932"
                          type="text"
                          class="form-control required"
                          dir="ltr"
                          v-model="bankAcoount.HesabNo"
                          @keypress="
                            $ValidNumber($event, 15, false);
                            $BlockSuspiciousInput($event, 15);
                          "
                          @keydown="$BlockSuspiciousInput($event, 15)"
                        />
                        <input
                          v-else
                          type="text"
                          class="form-control required"
                          dir="ltr"
                          v-model="bankAcoount.HesabNo"
                          @keypress="
                            $ValidNumber($event, 12, false);
                            $BlockSuspiciousInput($event, 12);
                          "
                          @keydown="$BlockSuspiciousInput($event, 12)"
                        />
                      </div>

                      <div
                        class="user-info-identity-field user-info-identity-field--md"
                      >
                        <span class="user-info-identity-label">بانک</span>
                        <SelectCombo
                          @result="getSelectedBank"
                          :readFromAction="'SelAzaHesab/GetBanks'"
                          :isRequired="true"
                          :defaultItemText="bankAcoount.bankName"
                        ></SelectCombo>
                      </div>

                      <div
                        class="user-info-identity-field user-info-identity-field--md"
                      >
                        <span class="user-info-identity-label">وضعیت</span>
                        <div class="user-info-bank-status">
                          <span
                            class="user-info-bank-status__state"
                            :class="
                              bankAcoount.Active ? 'is-on' : 'is-off'
                            "
                          >
                            {{ bankAcoount.Active ? "فعال" : "غیرفعال" }}
                          </span>
                          <label class="user-info-bank-switch">
                            <input
                              type="checkbox"
                              class="required InputText"
                              id="AccountStatus"
                              v-model="bankAcoount.Active"
                              aria-label="وضعیت حساب بانکی"
                            />
                            <span
                              class="user-info-bank-switch__track"
                              aria-hidden="true"
                            ></span>
                          </label>
                        </div>
                      </div>
                    </div>

                    <div class="user-info-identity-footer user-info-bank-actions">
                      <button
                        v-if="editHesabMode == false"
                        type="button"
                        class="sv-btn sv-btn--primary sv-btn--wide user-info-bank-actions__btn"
                        @click="submitBankAcoount()"
                      >
                        ثبت
                      </button>
                      <button
                        v-else
                        type="button"
                        class="sv-btn sv-btn--primary sv-btn--wide user-info-bank-actions__btn"
                        @click="editBankAcoount()"
                      >
                        ویرایش
                      </button>
                      <button
                        type="button"
                        class="sv-btn sv-btn--ghost sv-btn--wide user-info-bank-actions__btn"
                        @click="
                          addBankAccount = false;
                          changeEditHesabMode(false);
                        "
                      >
                        لغو
                      </button>
                    </div>
                  </div>
                </template>
              </net-pa-card>
            </div>
            <!--original place-->
            <div
              class="tab-pane fade user-info-docs-tab"
              id="nav-file"
              role="tabpanel"
              aria-labelledby="nav-file-tab"
            >
              <net-pa-card :Compact="true">
                <template slot="content">
                  <div class="user-info-docs-grid">
                    <div
                      class="user-info-doc-upload"
                      :class="{ 'has-file': !!GetAddress(181070505) }"
                      @click="onDocUploadClick($event, 'shenasname1')"
                    >
                      <div class="user-info-doc-upload__text">
                        <strong class="user-info-doc-upload__title"
                          >صفحه اول شناسنامه</strong
                        >
                        <span class="user-info-doc-upload__hint">{{
                          GetAddress(181070505)
                            ? "برای تغییر تصویر کلیک کنید"
                            : "برای انتخاب تصویر کلیک کنید"
                        }}</span>
                      </div>
                      <div
                        class="user-info-doc-upload__preview"
                        title="انتخاب تصویر"
                      >
                        <i
                          class="fas fa-camera user-info-doc-upload__icon"
                          aria-hidden="true"
                        ></i>
                        <i
                          class="fas fa-plus user-info-doc-upload__plus"
                          aria-hidden="true"
                        ></i>
                        <uploader
                          :Idu="'shenasname1'"
                          v-if="$store.state.renderComponent"
                          :base64="GetBase(181070505)"
                          @Done="GetFile"
                          :attachId="GetId(181070505)"
                          :address="GetAddress(181070505)"
                          :grp="181070505"
                          :title="'صفحه اول شناسنامه'"
                          :MasterId="$session.get('UserInfoNetPa').wwwtblAzaId"
                        ></uploader>
                      </div>
                    </div>
                    <div
                      class="user-info-doc-upload"
                      :class="{ 'has-file': !!GetAddress(181070506) }"
                      @click="onDocUploadClick($event, 'shenasname2')"
                    >
                      <div class="user-info-doc-upload__text">
                        <strong class="user-info-doc-upload__title"
                          >صفحه دوم شناسنامه</strong
                        >
                        <span class="user-info-doc-upload__hint">{{
                          GetAddress(181070506)
                            ? "برای تغییر تصویر کلیک کنید"
                            : "برای انتخاب تصویر کلیک کنید"
                        }}</span>
                      </div>
                      <div
                        class="user-info-doc-upload__preview"
                        title="انتخاب تصویر"
                      >
                        <i
                          class="fas fa-camera user-info-doc-upload__icon"
                          aria-hidden="true"
                        ></i>
                        <i
                          class="fas fa-plus user-info-doc-upload__plus"
                          aria-hidden="true"
                        ></i>
                        <uploader
                          :Idu="'shenasname2'"
                          :base64="GetBase(181070506)"
                          @Done="GetFile"
                          v-if="$store.state.renderComponent"
                          :attachId="GetId(181070506)"
                          :address="GetAddress(181070506)"
                          :grp="181070506"
                          :title="'صفحه دوم شناسنامه'"
                          :MasterId="$session.get('UserInfoNetPa').wwwtblAzaId"
                        ></uploader>
                      </div>
                    </div>
                    <div
                      class="user-info-doc-upload"
                      :class="{ 'has-file': !!GetAddress(181070507) }"
                      @click="onDocUploadClick($event, 'cartmeli1')"
                    >
                      <div class="user-info-doc-upload__text">
                        <strong class="user-info-doc-upload__title"
                          >تصویر جلوی کارت ملی</strong
                        >
                        <span class="user-info-doc-upload__hint">{{
                          GetAddress(181070507)
                            ? "برای تغییر تصویر کلیک کنید"
                            : "برای انتخاب تصویر کلیک کنید"
                        }}</span>
                      </div>
                      <div
                        class="user-info-doc-upload__preview"
                        title="انتخاب تصویر"
                      >
                        <i
                          class="fas fa-camera user-info-doc-upload__icon"
                          aria-hidden="true"
                        ></i>
                        <i
                          class="fas fa-plus user-info-doc-upload__plus"
                          aria-hidden="true"
                        ></i>
                        <uploader
                          :Idu="'cartmeli1'"
                          @Done="GetFile"
                          :base64="GetBase(181070507)"
                          v-if="$store.state.renderComponent"
                          :attachId="GetId(181070507)"
                          :address="GetAddress(181070507)"
                          :grp="181070507"
                          :title="'تصویر جلوی کارت ملی'"
                          :MasterId="$session.get('UserInfoNetPa').wwwtblAzaId"
                        ></uploader>
                      </div>
                    </div>
                    <div
                      class="user-info-doc-upload"
                      :class="{ 'has-file': !!GetAddress(181070508) }"
                      @click="onDocUploadClick($event, 'cartmeli2')"
                    >
                      <div class="user-info-doc-upload__text">
                        <strong class="user-info-doc-upload__title"
                          >تصویر پشت کارت ملی</strong
                        >
                        <span class="user-info-doc-upload__hint">{{
                          GetAddress(181070508)
                            ? "برای تغییر تصویر کلیک کنید"
                            : "برای انتخاب تصویر کلیک کنید"
                        }}</span>
                      </div>
                      <div
                        class="user-info-doc-upload__preview"
                        title="انتخاب تصویر"
                      >
                        <i
                          class="fas fa-camera user-info-doc-upload__icon"
                          aria-hidden="true"
                        ></i>
                        <i
                          class="fas fa-plus user-info-doc-upload__plus"
                          aria-hidden="true"
                        ></i>
                        <uploader
                          :Idu="'cartmeli2'"
                          :base64="GetBase(181070508)"
                          @Done="GetFile"
                          v-if="$store.state.renderComponent"
                          :attachId="GetId(181070508)"
                          :address="GetAddress(181070508)"
                          :grp="181070508"
                          :title="'تصویر پشت کارت ملی'"
                          :MasterId="$session.get('UserInfoNetPa').wwwtblAzaId"
                        ></uploader>
                      </div>
                    </div>
                    <div
                      class="user-info-doc-upload"
                      :class="{ 'has-file': !!GetAddress(181070509) }"
                      @click="onDocUploadClick($event, 'others')"
                    >
                      <div class="user-info-doc-upload__text">
                        <strong class="user-info-doc-upload__title"
                          >سایر مدارک</strong
                        >
                        <span class="user-info-doc-upload__hint">{{
                          GetAddress(181070509)
                            ? "برای تغییر تصویر کلیک کنید"
                            : "برای انتخاب تصویر کلیک کنید"
                        }}</span>
                      </div>
                      <div
                        class="user-info-doc-upload__preview"
                        title="انتخاب تصویر"
                      >
                        <i
                          class="fas fa-camera user-info-doc-upload__icon"
                          aria-hidden="true"
                        ></i>
                        <i
                          class="fas fa-plus user-info-doc-upload__plus"
                          aria-hidden="true"
                        ></i>
                        <uploader
                          :Idu="'others'"
                          @Done="GetFile"
                          :base64="GetBase(181070509)"
                          v-if="$store.state.renderComponent"
                          :attachId="GetId(181070509)"
                          :address="GetAddress(181070509)"
                          :grp="181070509"
                          :title="'سایر مدارک'"
                          :MasterId="$session.get('UserInfoNetPa').wwwtblAzaId"
                        ></uploader>
                      </div>
                    </div>
                  </div>
                </template>
              </net-pa-card>
            </div>
            <div
              class="tab-pane fade"
              id="nav-Isar"
              role="tabpanel"
              aria-labelledby="nav-Isar-tab"
            >
              <net-pa-card :Compact="true">
                <template slot="content">
                  <div class="user-info-identity user-info-status-tab" dir="rtl">
                    <p
                      v-if="!rowsIsar.length"
                      class="user-info-status-empty"
                    >
                      موردی برای نمایش وجود ندارد
                    </p>
                    <template v-else>
                    <section
                      v-for="(row, index) in rowsIsar"
                      :key="'isar-' + index"
                      class="user-info-identity-section user-info-status-card"
                    >
                      <h6 class="user-info-identity-section__title">
                        <i class="fas fa-flag" aria-hidden="true"></i>
                        وضعیت ایثارگری
                      </h6>
                      <div class="user-info-identity-fields">
                        <div class="user-info-identity-field user-info-identity-field--sm">
                          <span class="user-info-identity-label">آزادگی</span>
                          <div
                            class="user-info-readonly"
                            :class="
                              row.isAzade
                                ? 'user-info-isar-yes'
                                : 'user-info-isar-no'
                            "
                          >
                            <i
                              class="fas"
                              :class="row.isAzade ? 'fa-check' : 'fa-times'"
                              aria-hidden="true"
                            ></i>
                            {{ row.isAzade ? "بله" : "خیر" }}
                          </div>
                        </div>
                        <div class="user-info-identity-field user-info-identity-field--sm">
                          <span class="user-info-identity-label">جانبازی</span>
                          <div
                            class="user-info-readonly"
                            :class="
                              row.isJanbaz
                                ? 'user-info-isar-yes'
                                : 'user-info-isar-no'
                            "
                          >
                            <i
                              class="fas"
                              :class="row.isJanbaz ? 'fa-check' : 'fa-times'"
                              aria-hidden="true"
                            ></i>
                            {{ row.isJanbaz ? "بله" : "خیر" }}
                          </div>
                        </div>
                        <div class="user-info-identity-field user-info-identity-field--sm">
                          <span class="user-info-identity-label">رزمنده</span>
                          <div
                            class="user-info-readonly"
                            :class="
                              row.isRazmande
                                ? 'user-info-isar-yes'
                                : 'user-info-isar-no'
                            "
                          >
                            <i
                              class="fas"
                              :class="row.isRazmande ? 'fa-check' : 'fa-times'"
                              aria-hidden="true"
                            ></i>
                            {{ row.isRazmande ? "بله" : "خیر" }}
                          </div>
                        </div>
                        <div class="user-info-identity-field user-info-identity-field--md">
                          <span class="user-info-identity-label"
                            >خانواده شهید</span
                          >
                          <div
                            class="user-info-readonly"
                            :class="
                              row.isKhanevadeShahid
                                ? 'user-info-isar-yes'
                                : 'user-info-isar-no'
                            "
                          >
                            <i
                              class="fas"
                              :class="
                                row.isKhanevadeShahid ? 'fa-check' : 'fa-times'
                              "
                              aria-hidden="true"
                            ></i>
                            {{ row.isKhanevadeShahid ? "بله" : "خیر" }}
                          </div>
                        </div>
                        <div class="user-info-identity-field user-info-identity-field--md">
                          <span class="user-info-identity-label"
                            >برادر شهید</span
                          >
                          <div
                            class="user-info-readonly"
                            :class="
                              row.isBaradarShahid
                                ? 'user-info-isar-yes'
                                : 'user-info-isar-no'
                            "
                          >
                            <i
                              class="fas"
                              :class="
                                row.isBaradarShahid ? 'fa-check' : 'fa-times'
                              "
                              aria-hidden="true"
                            ></i>
                            {{ row.isBaradarShahid ? "بله" : "خیر" }}
                          </div>
                        </div>
                        <div class="user-info-identity-field user-info-identity-field--sm">
                          <span class="user-info-identity-label"
                            >مدت اسارت (سال)</span
                          >
                          <div class="user-info-readonly" dir="ltr">
                            {{
                              row.salEsarat != null && row.salEsarat !== ""
                                ? row.salEsarat
                                : "—"
                            }}
                          </div>
                        </div>
                        <div class="user-info-identity-field user-info-identity-field--sm">
                          <span class="user-info-identity-label"
                            >درصد جانبازی</span
                          >
                          <div class="user-info-readonly" dir="ltr">
                            {{
                              row.darsadJanbazi != null &&
                              row.darsadJanbazi !== ""
                                ? row.darsadJanbazi
                                : "—"
                            }}
                          </div>
                        </div>
                        <div class="user-info-identity-field user-info-identity-field--md">
                          <span class="user-info-identity-label"
                            >تعداد ماه عملیات</span
                          >
                          <div class="user-info-readonly" dir="ltr">
                            {{
                              row.mahAmaliyat != null && row.mahAmaliyat !== ""
                                ? row.mahAmaliyat
                                : "—"
                            }}
                          </div>
                        </div>
                      </div>
                    </section>
                    </template>
                  </div>
                </template>
              </net-pa-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import NetPaTab from "../Tools/NetPa/NetPaTab.vue";
import Panel from "../Tools/NetPa/Panel.vue";
import loading from "../Tools/NetPa/Loading.vue";
import uploader from "./Componenets/NetpaUploader.vue";
import SelectCombo from "@/components/Tools/SelectCombo.vue";
export default {
  data() {
    return {
      //AccountStatus: true,
      showIsarTable: false,
      editHesabMode: false,
      IsrequiredEstelamSabtAhval: false,
      EstelamSabtAhvalIsSuccess: false,
      DataAxiosEstelamSabtAhval: {
        CodeMeli: "",
        Mobile: "",
        BirthDate: "",
        CustCode: this.$session.get("CustCode"),
      },
      // DataAxiosEstelamSabtAhval: { CodeMeli: '', Mobile: '', BirthDate: '', CustCode: 7777 },
      stage: 1,
      ResultStage1: {},
      ResultStage2: {},
      randomKey: null,
      FixInput: false,
      value: null,
      file: [],
      UserInfo: {},
      defaultAvatar: "/Template/NewMenu/img/userNew.jpg",
      bankAcoount: { NameSahebHesab: "", Active: true },
      newpass: "",
      oldpass: "",
      addBankAccount: false,
      canChange: {},
      newpasscomfirm: "",
      DataAxiosChange: {
        ArryfildValue: "",
        Method: "Post",
        Action: "UpdPass/netpaUpdPass",
        Token: this.$session.get("TokenNetPa"),
      },
      loadingRender: false,
      rows: [],
      columns: [
        { label: "نام صاحب حساب", name: "nameSahebHesab" },
        { label: "نام بانک ", name: "bankName" },
        { label: "شماره حساب", name: "hesabNo" },
        { label: "شماره کارت", name: "cardNo" },
        { label: "شماره شبا", name: "shebaNo" },
        { label: "ویرایش", name: "edit" },
      ],
      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: "",
        card_mode: false,
        global_search: {
          placeholder: "  جستجو   ",
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: "table-bordered table-striped table-sm ",
      },
      columnsIsar: [
        { label: "آزادگی", name: "isAzade" },
        { label: "جانبازی", name: "isJanbaz" },
        { label: "رزمنده", name: "isRazmande" },
        { label: "مدت اسارت (سال)", name: "salEsarat" },
        { label: "درصد جانبازی", name: "darsadJanbazi" },
        { label: "تعداد ماه عملیات", name: "mahAmaliyat" },
        { label: "خانواده شهید", name: "isKhanevadeShahid" },
        { label: "برادر شهید", name: "isBaradarShahid" },
      ],
      rowsIsar: [],
      tabMenus: this.$session
        .get("AccessMenu")
        .filter((x) => x.routeName == "Tab"),
      EstlamSuccess: false,
    };
  },
  components: {
    NetPaCard,
    NetPaTab,
    Panel,
    loading,
    uploader,
    SelectCombo,
  },
  created() {
    this.changeEditHesabMode(false);
    this.IsrequiredEstelamSabtAhval = this.$GetIsrequiredEstelamSabtAhval();

    if (this.NeedEstelam === "true") {
      this.DataAxiosEstelamSabtAhval.CodeMeli = this.$session
        .get("UserInfoNetPa")
        .codeMeli.trim();
    }
    if (
      this.$session.get("CustCode") == "932" ||
      this.$session.get("CustCode") == "8002" ||
      this.$session.get("CustCode") == "953"
    ) {
      this.FixInput = true;
      this.bankAcoount.NameSahebHesab =
        this.$session.get("UserInfoNetPa").ozvName +
        " " +
        this.$session.get("UserInfoNetPa").ozvFamily;
    }
    if (this.$session.get("CustCode") == 948) {
      this.FixInput = true;
    }
    this.getAzaNoe();
    // this.UserInfo = JSON.parse(JSON.stringify(this.$session.get('UserInfoNetPa')))
    // this.UserInfo.codeMeli = this.UserInfo.codeMeli.trim()
    // this.UserInfo.shomareOzv = this.UserInfo.shomareOzv.trim()

    this.GetOzv();
    this.$FetchAzaPic();
    this.GEtAzaHesab();
    this.GEtAzaIsar();
  },
  mounted() {
    if (this.NeedEstelam === "true") {
      document.documentElement.classList.add("user-info-estelam-html");
      document.body.classList.add("user-info-estelam-html");
    }
    this.GetFile();
    if (this.$route.query.autoClick === "true") {
      document.getElementById("nav-BankAccount-tab").click();
    }
  },
  beforeDestroy() {
    document.documentElement.classList.remove("user-info-estelam-html");
    document.body.classList.remove("user-info-estelam-html");
  },
  methods: {
    onTabChange(id) {
      this.showIsarTable = id == "nav-Isar";
    },
    openDocUpload(id) {
      this.$nextTick(() => {
        const input = document.getElementById(id);
        if (input) input.click();
      });
    },
    onDocUploadClick(event, id) {
      if (
        event.target.closest(
          ".fa-trash, .fa-download, a[download], input[type='file']",
        )
      ) {
        return;
      }
      this.openDocUpload(id);
    },
    changeEditHesabMode(status) {
      this.editHesabMode = status;
      if (!status) {
        this.bankAcoount.ShebaNo = "";
        this.bankAcoount.HesabNo = "";
        this.bankAcoount.CardNo = "";
        this.bankAcoount.bankName = "";
        this.bankAcoount.Active = true;
      }
    },
    submitBankAcoount() {
      if (this.$session.get("CustCode") == 948) {
        this.Estelam().then((res) => {
          // this.bankAcoount.NameSahebHesab=res
          this.$mySweetDefaultTost(
            "استعلام موفق",
            "استعلام شماره شبا با موفقیت انجام شد",
            "success",
            2000,
          );
          if (!this.$ValidForm("addAccountBank")) {
            return;
          } else {
            this.AddOrEditAzaHesab(false);
            return;
          }
        });
      } else {
        if (
          !this.$ValidForm("addAccountBank") &&
          (this.$session.get("CustCode") == "932" ||
            this.$session.get("CustCode") == 948)
        ) {
          return;
        }
        this.AddOrEditAzaHesab(false);
      }
    },
    editBankAcoount() {
      if (this.$session.get("CustCode") == 948) {
        this.Estelam().then((res) => {
          // this.bankAcoount.NameSahebHesab=res
          this.$mySweetDefaultTost(
            "استعلام موفق",
            "استعلام شماره شبا با موفقیت انجام شد",
            "success",
            2000,
          );
          if (!this.$ValidForm("addAccountBank")) {
            return;
          } else {
            this.AddOrEditAzaHesab(true);
            return;
          }
        });
      } else {
        if (
          !this.$ValidForm("addAccountBank") &&
          (this.$session.get("CustCode") == "932" ||
            this.$session.get("CustCode") == 948)
        ) {
          return;
        }
        this.AddOrEditAzaHesab(true);
      }
    },
    AddOrEditAzaHesab(isEdit) {
      // this.bankAcoount.Active = this.AccountStatus;
      if (
        this.$session.get("CustCode") != "932" &&
        this.bankAcoount.ShebaNo.length != 24
      ) {
        this.$mySweetDefaultTost(
          "",
          "شماره شبا باید 24 رقم باشد",
          "error",
          3000,
        );
        return;
      }
      if (
        this.$session.get("CustCode") != "932" &&
        this.$session.get("CustCode") != "948" &&
        this.bankAcoount.CardNo.length != 16
      ) {
        this.$mySweetDefaultTost(
          "",
          "شماره کارت باید 16 رقم باشد",
          "error",
          3000,
        );
        return;
      }
      if (
        this.$session.get("CustCode") != "948" &&
        this.$session.get("CustCode") != "932" &&
        this.bankAcoount.HesabNo.length < 5
      ) {
        this.$mySweetDefaultTost("", "شماره حساب مجاز نیست", "error", 3000);
        return;
      }

      if (
        this.$session.get("CustCode") == "932" &&
        (this.bankAcoount.HesabNo.length < 5 ||
          this.bankAcoount.HesabNo.length > 12)
      ) {
        this.$mySweetDefaultTost("", "شماره حساب مجاز نیست", "error", 3000);
        return;
      }
      if (!isEdit) {
        this.$PostData_new(
          "SelAzaHesab/AddBankAccount",
          "post",
          this.bankAcoount,
        )
          .then((res) => {
            if (res.data == false) {
              this.$mySweetDefaultTost(
                "",
                "در ثبت اطلاعات مشکلی پیش آمده لطفا مجددا تلاش کنید ",
                "warning",
                3000,
              );
            } else {
              this.$mySweetDefaultTost(
                "",
                "اطلاعات با موفقیت افزوده شد",
                "success",
                2000,
              );
              this.GEtAzaHesab();
              this.addBankAccount = false;
            }
          })
          .catch((err) => {
            this.$mySweetDefaultTost("", "خطای سمت سرور", "error", 2000);
            console.error("e", err);
          });
      } else {
        this.$PostData_new(
          "SelAzaHesab/EditBankAccount",
          "post",
          this.bankAcoount,
        )
          .then((res) => {
            if (res.data == false) {
              this.$mySweetDefaultTost(
                "",
                "در ویرایش اطلاعات مشکلی پیش آمده لطفا مجددا تلاش کنید ",
                "warning",
                3000,
              );
            } else {
              this.$mySweetDefaultTost(
                "",
                "اطلاعات با موفقیت ویرایش شد",
                "success",
                2000,
              );
              this.GEtAzaHesab();
              this.addBankAccount = false;
            }
          })
          .catch((err) => {
            this.$mySweetDefaultTost("", "خطای سمت سرور", "error", 2000);
            console.error("e", err);
          });
      }
    },
    // دسترسی نمایش تب ها که از جدول wwwtblMenu میخونه
    showTab(num) {
      try {
        let tab = this.tabMenus.find((x) => x.params == num);
        if (num != 0 && num != 1 && this.NeedEstelam === "true") {
          return false;
        }
        if (
          (num == 0 || num == 1) &&
          this.NeedEstelam === "true" &&
          this.EstlamSuccess == false
        ) {
          return false;
        }
        return tab.isMenu;
      } catch (err) {
        console.error("e", err);
        return true;
      }
    },
    bankAccountChange(add) {
      this.addBankAccount = add;
    },
    Estelam() {
      return new Promise((success, reject) => {
        this.loadingRender = true;

        var data = {
          CustCode: this.$session.get("CustCode"),
          Sign: "",
          IbanNumber: "IR" + this.bankAcoount.ShebaNo,
        };
        var EstelamAxios = {
          action: "EstelamSheba/Index",
          method: "POST",
          arryfildValue: data,
        };

        this.$PostData_netpatoken(EstelamAxios)
          .then((result) => {
            if (typeof result == "string" || result.isSuccess == false) {
              var message = result == "string" ? result : result.message;
              this.$mySweetDefault("خطا", message, "error", 2000);
              this.bankAcoount.NameSahebHesab = "";
            } else {
              let FName = String(
                result.ibanAccountOwnerList[0].firstName +
                  " " +
                  result.ibanAccountOwnerList[0].lastName,
              );
              this.bankAcoount.NameSahebHesab = FName;
              success(FName);
            }
          })
          .finally(() => {
            this.loadingRender = false;
          });
      });
    },
    GetAddress(id) {
      var binary = this.file.find((x) => x.wwwtblcomboidgrp328 == id);
      if (binary) {
        if (
          binary.filename.indexOf(".PDF") > 0 ||
          binary.filename.indexOf(".pdf") > 0
        ) {
          return "/Image/PdfFile.png";
        }
        if (
          binary.filename.indexOf(".zip") > 0 ||
          binary.filename.indexOf(".rar") > 0
        ) {
          return "/Image/ZipFile.png";
        }
        return "data:image/png;base64," + binary.binary;
      } else {
        return null;
      }
    },
    GetId(id) {
      var binary = this.file.find((x) => x.wwwtblcomboidgrp328 == id);
      if (binary) {
        return binary.id;
      } else {
        return null;
      }
    },
    GetFile() {
      var dataAxios = {
        Method: "POST",
        Action: "Uploader/GetFile",
        ArryfildValue: {
          MasterId: this.$session.get("UserInfoNetPa").wwwtblAzaId,
          tableName: "wwwtblaza",
        },
      };
      this.$PostData(dataAxios).then((result) => {
        if (result.data !== undefined) {
          this.file = result.data;
          this.$store.state.renderComponent = false;
          this.$nextTick(() => {
            this.$store.state.renderComponent = true;
          });
        } else {
          this.file = [];
        }
      });
    },
    getSelectedBank(item) {
      this.bankAcoount.WwwtblBankId = item.bnpcashDbId;
    },
    ChangePass() {
      if (this.$ValidForm("divpass")) {
        if (this.newpasscomfirm == this.newpass) {
          this.loadingRender = true;
          const formData = new FormData();
          formData.append(
            "CustCode",
            this.$session.get("UserInfoNetPa").custCode,
          );
          formData.append(
            "CodeMeli",
            this.$session.get("UserInfoNetPa").codemeli,
          );
          formData.append("AxarinTaghirPass", this.$store.state.JalaliDate);
          formData.append("wwwtblazaId", this.$session.get("UserInfoNetPa").id);
          formData.append("NewPassword", this.$Encryption(this.newpass));
          formData.append("OldPass", this.$Encryption(this.oldpass));

          this.DataAxiosChange.ArryfildValue = formData;
          this.$PostFormData(this.DataAxiosChange).then((data) => {
            if (data.status) {
              this.$mySweetDefaultTost("خطا", data.msg, "warning", 2000);
              this.loadingRender = false;
            } else {
              if (data.id) {
                this.$mySweetDefaultTost(
                  "عملیات موفق",
                  "تغییر رمز با موفقیت انجام شد",
                  "success",
                  4000,
                );
                this.loadingRender = false;
                this.$router.push("/PishkhanNetPa/Home");
              }
            }
          });
        } else {
          this.$mySweetDefaultTost(
            "خطا",
            "رمز عبور وارد شده و تکرارش برابر نیستند!",
            "warning",
            2000,
          );
        }
      }
    },
    getSelectedCombo(item) {
      this.UserInfo.comboIdNoeEstekhdam33 = item.id;
    },
    UpdateUser() {
      if (this.$ValidForm("userInfoDiv")) {
        if (this.rows.length == 0 && this.NeedEstelam) {
          this.$mySweetDefaultTost(
            "عدم ثبت اطلاعات",
            "اطلاعات حساب بانکی یافت نشد لطفا اطلاعات حساب بانکی خودرا وارد نمایید",
            "warning",
            4000,
          );
          return;
        }
        this.$RemoveAlert("از صحت اطلاعات اطمینان دارید").then((res) => {
          if (res) {
            var form_data = new FormData();
            for (var key in this.UserInfo) {
              form_data.append(key, this.UserInfo[key]);
            }
            form_data.append(
              "IsEstelamSabtAhval",
              this.NeedEstelam === "true" ? true : null,
            );
            var DataAxiosUpdate = {
              ArryfildValue: form_data,
              Method: "Post",
              Action: "UpdAza",
              Token: this.$session.get("TokenNetPa"),
            };
            this.$PostFormData(DataAxiosUpdate).then((data) => {
              if (data.id) {
                if (this.NeedEstelam === "true") {
                  this.$mySweetDefault(
                    "عملیات موفق",
                    "احراز هویت شما با موفقیت انجام شد و اطلاعات شما بروز گردید ، لطفا جهت بروزرسانی اطلاعات شما دوباره وارد سیستم شوید",
                    "success",
                    4000,
                  );
                  this.LogOut();
                  return;
                }
                this.$mySweetDefaultTost(
                  "عملیات موفق",
                  "اطلاعات با موفقیت بروز شدند",
                  "success",
                  2000,
                );
              } else {
                this.$mySweetDefaultTost(
                  "عملیات ناموفق",
                  "مشکلی در ثبت اطلاعات بوجود آمده است. دوباره تلاش کنید",
                  "error",
                  2000,
                );
              }
            });
          }
        });
      }
    },
    getAzaNoe() {
      var formdata = new FormData();
      formdata.append(
        "wwwtblShobeId",
        this.$session.get("UserInfoNetPa").wwwtblShobeId,
      );
      formdata.append(
        "wwwtblAzaNoeId",
        this.$session.get("UserInfoNetPa").wwwtblAzaNoeId,
      );
      var DataAxiosUpdate = {
        ArryfildValue: formdata,
        Method: "POST",
        Action: "Dastresi",
        Token: this.$session.get("TokenNetPa"),
      };
      this.$PostFormData(DataAxiosUpdate).then((data) => {
        if (this.$session.get("UserInfoNetPa").cId != "801") {
          this.canChange = data;
        }
      });
    },
    checkregex(e) {
      let char = String.fromCharCode(e.keyCode);
      if (!/^[A-Za-z0-9]+$/.test(char)) {
        this.$mySweetDefaultTost(
          "خطا",
          "فقط حروف انگلیسی و اعداد  مجاز هستند",
          "error",
          2000,
        );
        e.preventDefault();
      }
    },
    GetBase(id) {
      var binary = this.file.find((x) => x.wwwtblcomboidgrp328 == id);
      if (binary) {
        return binary;
      } else {
        return null;
      }
    },
    GetOzv() {
      var formData = new FormData();
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      var DataAxios = {
        Method: "Post",
        Action: "SelAza",
        ArryfildValue: formData,
        Token: this.$session.get("TokenNetPa"),
      };
      this.$PostFormData(DataAxios).then((result) => {
        this.UserInfo = result;
        this.UserInfo.codeMeli = this.UserInfo.codeMeli.trim();
        this.UserInfo.shomareOzv = this.UserInfo.shomareOzv.trim();
      });
    },
    GEtAzaHesab(hesabId) {
      var formData = new FormData();
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      var DataAxios = {
        Method: "Post",
        Action: "SelAzaHesab",
        ArryfildValue: formData,
        Token: this.$session.get("TokenNetPa"),
      };
      this.$PostFormData(DataAxios).then((result) => {
        if (hesabId == null) {
          this.rows = result;
        } else {
          var x = result.find((x) => x.id === hesabId);
          this.bankAcoount.ShebaNo =
            x.shebaNo === null || x.shebaNo == ""
              ? x.shebaNo
              : x.shebaNo.trim().replace(/^IR/, "");
          this.bankAcoount.HesabNo =
            x.hesabNo === null || x.hesabNo == ""
              ? x.hesabNo
              : x.hesabNo.trim();
          this.bankAcoount.CardNo =
            x.cardNo === null || x.cardNo == "" ? x.cardNo : x.cardNo.trim();
          this.bankAcoount.bankName =
            x.bankName === null || x.bankName == ""
              ? x.bankName
              : x.bankName.trim();
          this.bankAcoount.Id = x.id;
          this.bankAcoount.Active = x.active;
          this.changeEditHesabMode(true);
          this.addBankAccount = true;
        }
      });
    },
    GEtAzaIsar() {
      var formData = new FormData();
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      var DataAxios = {
        Method: "Post",
        Action: "IsarGari",
        ArryfildValue: formData,
        Token: this.$session.get("TokenNetPa"),
      };
      this.$PostFormData(DataAxios).then((result) => {
        this.rowsIsar = Array.isArray(result) ? result : [];
      });
    },
    sendSms(IdFormValid) {
      if (!this.$ValidForm(IdFormValid)) {
        return;
      }

      this.loadingRender = true;
      this.$PostData_new(
        "GetInfocodeMeli",
        "POST",
        this.DataAxiosEstelamSabtAhval,
      ).then((re) => {
        // console.log("😂 ~ re:", re)
        if (re.result == "false") {
          this.$mySweetDefaultTost("خطا", re.msg, "error", 3800);
        }
        if (re.result == "faild") {
          this.$mySweetDefaultTost("عدم احراز هویت", re.msg, "warning", 4500);
        }
        if (re.result == "success" && re.type == "2") {
          this.ResultStage1 = re;
          this.stage = 2;
          this.$mySweetDefaultTost(
            "ارسال موفق",
            "کد احراز هویت برای شما پیامک شد ، دریافت کد به علت ترافیک پیامک ها ممکن است کمی زمان بر باشد",
            "success",
            4500,
          );
        }
        if (re.result == "success" && re.type == "1") {
          this.loadingRender = false;
          this.$mySweetDefaultTost(
            "احراز موفق",
            "کاربر گرامی : " +
              re.data.name +
              " " +
              re.data.family +
              " احراز هویت شما با موفقیت انجام گردید ",
            "success",
            4800,
          );
          this.stage = 3;
          this.ResultStage2 = re.data;
          this.EstlamSuccess = true;
          this.FixInput = true;
          this.UserInfo.ozvName = re.data.name;
          this.UserInfo.ozvFamily = re.data.family;
          this.UserInfo.codeMeli = re.data.idCode;
          this.UserInfo.birthDate = re.data.birthDate;
          this.UserInfo.mobile = re.data.mobile;
          this.UserInfo.pedar = re.data.fatherName;
          this.UserInfo.shenasname = re.data.shomareShenasname;
        }
        this.loadingRender = false;
      });
    },
    OkCode(IdFormValid) {
      if (!this.$ValidForm(IdFormValid)) {
        return;
      }
      this.loadingRender = true;
      let Model = {
        ResultId: this.ResultStage1.data.result.id,
        ComfirmMobile: this.randomKey,
      };
      this.$PostData_new("GetInfocodeMeliByOTP", "POST", Model).then((re) => {
        if (re == null || re.result == "false" || re.result.idCode == null) {
          this.$mySweetDefaultTost(
            "خطا",
            re.result == "false"
              ? re.msg
              : "خطا در بررسی کد احراز هویت ، کد وارد شده صحیح نیست",
            "error",
            4800,
          );
          this.loadingRender = false;
          this.stage = 2;
          return;
        }
        if (re.result.id != null && re.result.id.trim() != "") {
          this.loadingRender = false;
          this.$mySweetDefaultTost(
            "احراز موفق",
            "کاربر گرامی : " +
              re.result.name +
              " " +
              re.result.family +
              " احراز هویت شما با موفقیت انجام گردید ",
            "success",
            4800,
          );
          this.stage = 3;
          this.ResultStage2 = re;
          this.EstlamSuccess = true;
          this.FixInput = true;
          this.UserInfo.ozvName = re.result.name;
          this.UserInfo.ozvFamily = re.result.family;
          this.UserInfo.codeMeli = re.result.idCode;
          this.UserInfo.birthDate = re.result.birthDate;
          this.UserInfo.mobile = re.result.mobile;
          this.UserInfo.pedar = re.result.fatherName;
          this.UserInfo.shenasname = re.result.nationalId;
        } else {
          this.$mySweetDefaultTost(
            "عملیات ناموفق",
            "خطایی رخ داد است",
            "error",
            2000,
          );
          this.loadingRender = false;
        }
        this.loadingRender = false;
      });
    },
    LogOut() {
      var DataAxios = {
        Method: "Post",
        Action: "Logout",
        ArryfildValue: {},
        Token: this.$session.get("TokenNetPa"),
      };
      this.$PostData(DataAxios).then((result) => {
        //console.log(result);
        this.$store.state.Netpa_Cart = [];
        this.$store.state.AzaPicSrc = "";
        this.$store.state.AzaPicId = null;
        this.$router.push("/");
        this.$session.clear();
        sessionStorage.removeItem("vuex");
        this.$store.state.PanelRout = [];
        this.$ResetTimer();
      });
    },
  },
  computed: {
    UserTabs() {
      const tabs = [];
      if (this.showTab(0)) tabs.push({ id: "nav-home", title: "اطلاعات هویتی" });
      if (this.showTab(1))
        tabs.push({ id: "nav-BankAccount", title: "حساب‌های بانکی" });
      if (this.showTab(3)) tabs.push({ id: "nav-file", title: "بارگذاری مدارک" });
      if (this.showTab(4)) tabs.push({ id: "nav-Isar", title: "وضعیت ایثارگری" });
      return tabs;
    },
    avatarSrc() {
      return this.$store.state.AzaPicSrc || this.defaultAvatar;
    },
  },
  props: {
    NeedEstelam: {
      default: "false",
    },
  },
};
</script>
<style>
#UserInfo .user-info-change-pass-content {
  width: 100%;
}

#UserInfo .user-info-change-pass-alert {
  margin-bottom: 1rem;
  text-align: right;
}

#UserInfo .user-info-change-pass-alert__list {
  list-style: decimal;
  padding-right: 1.25rem;
  font-size: 14px;
}

#UserInfo .user-info-change-pass-form {
  width: 100%;
  max-width: 520px;
  margin: 0 auto;
  direction: rtl;
}

#UserInfo .user-info-change-pass-field {
  margin-bottom: 0.75rem;
}

#UserInfo .user-info-change-pass-actions {
  margin-top: 1rem;
}

#UserInfo .user-info-change-pass-submit-btn {
  width: 100%;
  min-height: 40px;
  border-radius: 8px;
  font-weight: 600;
}

#UserInfo.user-info-estelam {
  min-height: 100vh;
  padding: 12px 16px 28px;
  box-sizing: border-box;
  background: #f5f7fb !important;
}

#UserInfo .user-info-estelam-shell {
  width: 100%;
  max-width: 560px;
  margin-left: auto;
  margin-right: auto;
}

#UserInfo .user-info-auth {
  display: grid;
  gap: 12px;
}

#UserInfo .user-info-auth-hint {
  margin: 0;
  padding: 8px 12px;
  color: #31465f;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.7;
  border: 1px solid #dbe5eb;
  border-radius: 10px;
  background: #edf5fb;
}

#UserInfo .user-info-auth-form {
  display: grid;
  gap: 12px;
  max-width: none;
  margin: 0;
  padding: 0;
}

#UserInfo .user-info-auth-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

#UserInfo .user-info-auth-field {
  min-width: 0;
  text-align: right;
}

#UserInfo .user-info-auth-field label {
  display: block;
  margin-bottom: 6px;
  color: #31465f;
  font-size: 12px;
  font-weight: 700;
}

#UserInfo .user-info-auth-input,
#UserInfo .user-info-auth-field .form-control {
  width: 100%;
  min-height: 40px;
  height: 40px;
  padding: 0.45rem 0.7rem;
  color: #13243a;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  border: 1px solid #dbe5eb;
  border-radius: 10px;
  background: #fff;
  box-shadow: none;
}

#UserInfo .user-info-auth-input:disabled {
  color: #8b98a8;
  background: #f5f7fb;
}

#UserInfo .user-info-auth-input:focus,
#UserInfo .user-info-auth-field .form-control:focus {
  outline: none;
  border-color: #05b8c8;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
}

#UserInfo .user-info-auth-actions {
  display: flex;
  justify-content: flex-start;
}

#UserInfo .user-info-auth-submit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 148px;
  min-height: 40px;
  padding: 8px 16px;
  color: #fff;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 700;
  border: 0;
  border-radius: 12px;
  background: linear-gradient(110deg, #29345f, #56508d 58%, #8d58a4);
  box-shadow: 0 10px 20px rgba(41, 52, 95, 0.16);
  cursor: pointer;
}

#UserInfo .user-info-auth-submit:hover {
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 14px 24px rgba(41, 52, 95, 0.22);
}

#UserInfo .user-info-auth-field--date .vpd-main {
  display: block;
  width: 100%;
}

#UserInfo .user-info-auth-field--date .vpd-input-group {
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: 40px;
  overflow: hidden;
  border: 1px solid #dbe5eb;
  border-radius: 10px;
  background: #fff;
}

#UserInfo .user-info-auth-field--date .vpd-input-group:focus-within {
  border-color: #05b8c8;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
}

#UserInfo .user-info-auth-field--date .vpd-input-group input,
#UserInfo .user-info-auth-field--date .vpd-input-group input.form-control {
  flex: 1 1 auto;
  width: 100%;
  min-width: 0;
  height: 40px;
  min-height: 40px;
  margin: 0;
  padding: 0.4rem 0.75rem;
  border: none !important;
  border-radius: 0 !important;
  background: transparent;
  box-shadow: none !important;
}

#UserInfo .user-info-auth-field--date .vpd-input-group .vpd-icon-btn {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: auto !important;
  min-width: 2.4rem;
  margin: 0 !important;
  padding: 0 0.6rem !important;
  color: #068997;
  border: none;
  background: #e9f9fb;
}

@media (max-width: 767px) {
  #UserInfo.user-info-estelam {
    padding: 8px;
  }

  #UserInfo .user-info-estelam-shell {
    max-width: none;
  }

  #UserInfo .user-info-estelam-shell > .row {
    margin-left: 0;
    margin-right: 0;
  }

  #UserInfo .user-info-estelam-shell > .row > [class*="col-"] {
    padding-left: 0;
    padding-right: 0;
  }

  #UserInfo.user-info-estelam .netpa-card {
    margin: 8px 0 !important;
  }

  #UserInfo .user-info-auth-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  #UserInfo .user-info-auth-submit {
    width: 100%;
  }
}

#UserInfo .user-info-identity-alert {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  margin: 0 0 1rem;
  padding: 0.85rem 1rem;
  color: #7a5410;
  background: #fdf8ef;
  border: 1px solid #eed9b0;
  border-radius: 12px;
}

#UserInfo .user-info-identity-alert i {
  margin-top: 0.15rem;
  color: #c7922c;
  font-size: 16px;
}

#UserInfo .user-info-identity-alert p {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.7;
}

#UserInfo .user-info-identity {
  --bnp-brand-navy: #29345f;
  --bnp-brand-indigo: #56508d;
  --bnp-brand-purple: #8d58a4;
  --bnp-border-default: #dbe5eb;
  --bnp-focus-ring: 0 0 0 4px rgba(5, 184, 200, 0.2);
  --bnp-shadow-md: 0 12px 24px rgba(41, 52, 95, 0.18);
  --bnp-motion-fast: 180ms;
  --bnp-ease-standard: cubic-bezier(0.165, 0.84, 0.44, 1);
  --sv-control-h: 40px;

  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
}

#UserInfo .user-info-identity-hero {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.25rem;
  padding: 0.25rem 0 1rem;
  border-bottom: 1px solid #e8eef2;
}

#UserInfo .user-info-avatar {
  flex-shrink: 0;
  width: 88px;
  height: 88px;
  object-fit: cover;
  border-radius: 50%;
  border: 3px solid #edf5fb;
  box-shadow: 0 2px 8px rgba(41, 52, 95, 0.1);
  background: #f8fafc;
}

#UserInfo .user-info-identity-hero__meta {
  min-width: 0;
}

#UserInfo .user-info-identity-hero__name {
  margin: 0;
  color: #29345f;
  font-size: 16px !important;
  font-weight: 800;
  line-height: 1.45;
}

#UserInfo .user-info-identity-hero__id {
  margin: 0.2rem 0 0;
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 600;
}

#UserInfo .user-info-identity-verified {
  display: inline-flex;
  align-items: flex-start;
  gap: 0.5rem;
  margin-top: 0.55rem;
  padding: 0.45rem 0.7rem;
  color: #166c3b;
  background: #f3faf6;
  border: 1px solid #cfe8d8;
  border-radius: 10px;
}

#UserInfo .user-info-identity-verified i {
  margin-top: 0.15rem;
  font-size: 14px;
}

#UserInfo .user-info-identity-verified strong {
  display: block;
  font-size: 12px;
  font-weight: 800;
}

#UserInfo .user-info-identity-verified span {
  display: block;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.5;
}

#UserInfo .user-info-identity-section {
  padding: 1rem 0 0.25rem;
}

#UserInfo .user-info-identity-section + .user-info-identity-section {
  margin-top: 0.35rem;
  border-top: 1px solid #e8eef2;
}

#UserInfo .user-info-identity-section__title {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  margin: 0 0 0.85rem;
  color: #29345f;
  font-size: 13px !important;
  font-weight: 800;
}

#UserInfo .user-info-identity-section__title i {
  color: #56508d;
  font-size: 12px;
}

#UserInfo .user-info-identity-fields {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  align-items: end;
  gap: 0.85rem 0.9rem;
}

#UserInfo .user-info-identity-field {
  display: flex;
  flex-direction: column;
  grid-column: span 1;
  min-width: 0;
  width: auto;
  max-width: none;
  margin: 0;
}

#UserInfo .user-info-identity-field--wide {
  grid-column: span 3;
}

#UserInfo .user-info-identity-label {
  display: block;
  margin-bottom: 0.35rem;
  min-height: 1.25rem;
  color: #29345f;
  font-size: 13px !important;
  font-weight: 700;
  line-height: 1.25rem;
  white-space: nowrap;
}

#UserInfo .user-info-identity-field .form-control {
  width: 100%;
  height: 40px;
  min-height: 40px;
  padding: 0.4rem 0.75rem;
  color: #13243a;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  text-align: right;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(41, 52, 95, 0.06);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

#UserInfo .user-info-identity-field .form-control:focus {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
  outline: none;
}

#UserInfo .user-info-identity-field .form-control:disabled {
  color: #6b7b8e;
  background: #f8fafc;
}

#UserInfo .user-info-identity-field .form-control::placeholder {
  text-align: right;
  direction: rtl;
}

#UserInfo .user-info-identity-field .form-control.text-left,
#UserInfo .user-info-identity-field .form-control.required-CodeMeli {
  direction: ltr;
  text-align: left;
}

#UserInfo .user-info-identity-field .form-control.text-left::placeholder,
#UserInfo .user-info-identity-field .form-control.required-CodeMeli::placeholder,
#UserInfo .user-info-identity-field .form-control[dir="ltr"]::placeholder {
  text-align: right;
  direction: rtl;
}

#UserInfo .user-info-identity-fields .vpd-main {
  display: block;
  width: 100%;
}

#UserInfo .user-info-identity-fields .vpd-input-group {
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: 40px;
  overflow: hidden;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(41, 52, 95, 0.06);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

#UserInfo .user-info-identity-fields .vpd-input-group:focus-within {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
}

#UserInfo .user-info-identity-fields .vpd-input-group input,
#UserInfo .user-info-identity-fields .vpd-input-group input.form-control {
  flex: 1 1 auto;
  width: 100%;
  min-width: 0;
  height: 40px;
  min-height: 40px;
  margin: 0;
  padding: 0.4rem 0.75rem;
  border: none !important;
  border-radius: 0 !important;
  background: transparent;
  box-shadow: none !important;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
}

#UserInfo .user-info-identity-fields .vpd-input-group input:focus {
  outline: none;
  box-shadow: none !important;
}

#UserInfo .user-info-identity-fields .vpd-input-group .vpd-icon-btn {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  min-width: 2.4rem;
  margin: 0 !important;
  padding: 0 0.6rem !important;
  color: #287db4;
  border: none;
  background: #edf5fb;
}

#UserInfo .user-info-identity-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e8eef2;
}

#UserInfo .user-info-identity .sv-btn,
#UserInfo .user-info-bank-add .sv-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: var(--sv-control-h);
  padding: 6px 14px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.4;
  border-radius: 12px;
  cursor: pointer;
  transition:
    color var(--bnp-motion-fast) var(--bnp-ease-standard),
    background var(--bnp-motion-fast) var(--bnp-ease-standard),
    border-color var(--bnp-motion-fast) var(--bnp-ease-standard),
    box-shadow var(--bnp-motion-fast) var(--bnp-ease-standard),
    transform var(--bnp-motion-fast) var(--bnp-ease-standard);
}

#UserInfo .user-info-identity .sv-btn:focus,
#UserInfo .user-info-bank-add .sv-btn:focus {
  outline: none;
}

#UserInfo .user-info-identity .sv-btn:focus-visible,
#UserInfo .user-info-bank-add .sv-btn:focus-visible {
  box-shadow: var(--bnp-focus-ring);
}

#UserInfo .user-info-identity .sv-btn--primary,
#UserInfo .user-info-bank-add .sv-btn--primary {
  color: #fff;
  border: 0;
  background: linear-gradient(
    110deg,
    var(--bnp-brand-navy),
    var(--bnp-brand-indigo) 58%,
    var(--bnp-brand-purple)
  );
  box-shadow: var(--bnp-shadow-md);
}

#UserInfo .user-info-identity .sv-btn--primary:hover,
#UserInfo .user-info-bank-add .sv-btn--primary:hover {
  color: #fff;
  transform: translateY(-1px);
}

#UserInfo .user-info-identity .sv-btn--ghost,
#UserInfo .user-info-bank-add .sv-btn--ghost {
  color: var(--bnp-brand-navy);
  border: 1px solid var(--bnp-border-default);
  background: #fff;
}

#UserInfo .user-info-identity .sv-btn--ghost:hover,
#UserInfo .user-info-bank-add .sv-btn--ghost:hover {
  color: var(--bnp-brand-purple);
  border-color: rgba(141, 88, 164, 0.28);
  background: rgba(141, 88, 164, 0.05);
}

#UserInfo .user-info-identity .sv-btn--wide,
#UserInfo .user-info-bank-add .sv-btn--wide {
  min-width: 168px;
  min-height: 44px;
}

#UserInfo .user-info-status-tab__toolbar {
  justify-content: flex-end;
  margin-top: 0;
  margin-bottom: 0.35rem;
  padding-top: 0;
  border-top: 0;
}

#UserInfo .user-info-bank-list__toolbar {
  display: flex;
  justify-content: flex-end;
  margin: 0 0 0.9rem;
}

#UserInfo .user-info-bank-list__cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 0.9rem;
}

#UserInfo .user-info-bank-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: 1rem 1.05rem 0.95rem;
  border: 1px solid #e8eef2;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(41, 52, 95, 0.06);
}

#UserInfo .user-info-bank-card__header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem 0.75rem;
  margin-bottom: 0.75rem;
  padding-bottom: 0.7rem;
  border-bottom: 1px solid #e8eef2;
}

#UserInfo .user-info-bank-card__name {
  min-width: 0;
  color: #13243a;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.45;
}

#UserInfo .user-info-bank-card__badge {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 0.15rem 0.65rem;
  color: #8a6414;
  font-size: 12px;
  font-weight: 800;
  border-radius: 999px;
  background: #fff4d6;
}

#UserInfo .user-info-bank-card__fields {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}

#UserInfo .user-info-bank-card__field {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
}

#UserInfo .user-info-bank-card__field span {
  flex-shrink: 0;
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

#UserInfo .user-info-bank-card__field strong {
  min-width: 0;
  color: #13243a;
  font-size: 13px;
  font-weight: 700;
  text-align: left;
  overflow-wrap: anywhere;
  word-break: break-word;
}

#UserInfo .user-info-bank-card__actions {
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
}

#UserInfo .user-info-bank-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  min-height: 34px;
  padding: 0.3rem 0.75rem;
  border: 1px solid;
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(41, 52, 95, 0.05);
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease,
    color 0.15s ease, box-shadow 0.15s ease;
}

#UserInfo .user-info-bank-chip:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
}

#UserInfo .user-info-bank-chip--add {
  color: #2f7a1f;
  border-color: #b7dfb0;
  background: #eef8ec;
}

#UserInfo .user-info-bank-chip--add:hover,
#UserInfo .user-info-bank-chip--add:focus {
  color: #fff;
  border-color: #2f7a1f;
  background: #2f7a1f;
}

#UserInfo .user-info-bank-chip--edit {
  color: #287db4;
  border-color: #cfe4f2;
  background: #edf5fb;
}

#UserInfo .user-info-bank-chip--edit:hover,
#UserInfo .user-info-bank-chip--edit:focus {
  color: #fff;
  border-color: #287db4;
  background: #287db4;
}

#UserInfo .user-info-status-empty {
  margin: 0.75rem 0 0;
  padding: 1.5rem 1rem;
  color: #6b7b8e;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  border: 1px dashed #dbe5eb;
  border-radius: 14px;
  background: #f8fafc;
}

#UserInfo .user-info-readonly {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  width: 100%;
  min-height: 40px;
  padding: 0.4rem 0.75rem;
  color: #13243a;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.4;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  background: #f8fafc;
  box-shadow: 0 1px 3px rgba(41, 52, 95, 0.06);
  overflow-wrap: anywhere;
}

#UserInfo .user-info-readonly[dir="ltr"] {
  justify-content: flex-end;
  text-align: left;
}

#UserInfo .user-info-isar-yes {
  color: #166c3b;
  background: #f3faf6;
  border-color: #cfe8d8;
}

#UserInfo .user-info-isar-no {
  color: #b44f46;
  background: #fdf4f2;
  border-color: #f3d4d0;
}

#UserInfo .user-info-identity .sv-btn.user-info-status-edit {
  color: #287db4;
  border: 1px solid #d4e6f3;
  background: #f3f8fc;
  box-shadow: 0 1px 3px rgba(41, 52, 95, 0.06);
}

#UserInfo .user-info-identity .sv-btn.user-info-status-edit:hover {
  color: #fff;
  background: #287db4;
  border-color: #287db4;
}

#UserInfo .user-info-status-card .user-info-identity-label {
  white-space: normal;
}

#UserInfo .user-info-status-card .user-info-identity-field--md {
  grid-column: span 2;
}

#UserInfo .user-info-status-card .user-info-identity-field--lg {
  grid-column: span 3;
}

@media (max-width: 1199px) {
  #UserInfo .user-info-identity-fields {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  #UserInfo .user-info-identity-field--wide {
    grid-column: span 2;
  }

  #UserInfo .user-info-status-card .user-info-identity-field--lg {
    grid-column: span 2;
  }
}

@media (max-width: 767px) {
  #UserInfo .user-info-identity-hero {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  #UserInfo .user-info-identity-verified {
    justify-content: center;
    text-align: right;
  }

  #UserInfo .user-info-identity-fields {
    grid-template-columns: 1fr;
  }

  #UserInfo .user-info-identity-field,
  #UserInfo .user-info-identity-field--wide {
    grid-column: span 1;
  }

  #UserInfo .user-info-identity-label {
    white-space: normal;
  }

  #UserInfo .user-info-identity-footer {
    justify-content: stretch;
  }

  #UserInfo .user-info-identity .sv-btn--wide,
  #UserInfo .user-info-status-tab__toolbar .sv-btn,
  #UserInfo .user-info-status-card .user-info-identity-footer .sv-btn,
  #UserInfo .user-info-bank-list__toolbar .user-info-bank-chip,
  #UserInfo .user-info-bank-card__actions .user-info-bank-chip {
    width: 100%;
  }

  #UserInfo .user-info-bank-list__cards {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }

  #UserInfo .user-info-status-card .user-info-identity-field--md,
  #UserInfo .user-info-status-card .user-info-identity-field--lg,
  #UserInfo .user-info-bank-form .user-info-identity-field--md {
    grid-column: span 1;
  }
}

#UserInfo .user-info-auth-form .vpd-main {
  display: block;
  width: 100%;
}

#UserInfo .user-info-auth-form .vpd-input-group {
  display: flex;
  align-items: stretch;
  width: 100%;
  border: 1px solid #e8ecf1;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(42, 63, 84, 0.07);
  overflow: hidden;
}

#UserInfo .user-info-auth-form .vpd-input-group input {
  flex: 1 1 auto;
  min-width: 0;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  background: transparent;
}

#UserInfo .user-info-auth-form .vpd-input-group .vpd-icon-btn {
  flex: 0 0 auto;
  border: none;
  border-radius: 0;
  border-inline-start: 1px solid rgba(255, 255, 255, 0.28);
}

#UserInfo .user-info-docs-tab {
  padding-top: 0;
}

#UserInfo .user-info-docs-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}

#UserInfo .user-info-doc-upload {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-width: 0;
  min-height: 72px;
  padding: 14px 16px;
  border: 1px solid #eef1f6;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(41, 52, 95, 0.06);
  cursor: pointer;
}

#UserInfo .user-info-doc-upload:hover .user-info-doc-upload__preview {
  border-color: #05b8c8;
  background: #e7f7fa;
}

#UserInfo .user-info-doc-upload__text {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
  gap: 0.15rem;
}

#UserInfo .user-info-doc-upload__title {
  color: #1c2b3d;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.6;
}

#UserInfo .user-info-doc-upload__hint {
  color: #068997;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.5;
}

#UserInfo .user-info-doc-upload__preview {
  position: relative;
  flex: 0 0 56px;
  width: 56px;
  height: 56px;
  overflow: hidden;
  border: 1px dashed #b7c4d6;
  border-radius: 14px;
  background: #eef2fb;
}

#UserInfo .user-info-doc-upload.has-file .user-info-doc-upload__preview {
  border-style: solid;
  border-color: #dbe5eb;
}

#UserInfo .user-info-doc-upload__icon,
#UserInfo .user-info-doc-upload__plus {
  position: absolute;
  z-index: 1;
  color: #5b6f8a;
  pointer-events: none;
}

#UserInfo .user-info-doc-upload__icon {
  top: 50%;
  left: 46%;
  font-size: 18px;
  transform: translate(-50%, -50%);
}

#UserInfo .user-info-doc-upload__plus {
  right: 6px;
  bottom: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: #fff;
  font-size: 8px;
  border-radius: 50%;
  background: #05b8c8;
}

#UserInfo .user-info-doc-upload.has-file .user-info-doc-upload__icon,
#UserInfo .user-info-doc-upload.has-file .user-info-doc-upload__plus {
  display: none;
}

#UserInfo .user-info-doc-upload .container-fluid,
#UserInfo .user-info-doc-upload .container-fluid > .row,
#UserInfo .user-info-doc-upload .container-fluid > .row > [class*="col-"] {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

#UserInfo .user-info-doc-upload .container-fluid > .row {
  position: relative;
}

#UserInfo .user-info-doc-upload .col-12.text-center {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  overflow: hidden;
}

#UserInfo .user-info-doc-upload .col-12.text-center img,
#UserInfo .user-info-doc-upload .col-12.text-center img.w-100 {
  display: block;
  width: 56px !important;
  height: 56px !important;
  max-width: 56px !important;
  max-height: 56px !important;
  object-fit: cover;
  border-radius: 14px;
}

#UserInfo .user-info-doc-upload img[src*="OHUploader"] {
  opacity: 0;
}

#UserInfo .user-info-doc-upload .col-12:not(.text-center) {
  position: absolute;
  top: -10px;
  left: -6px;
  z-index: 2;
  width: auto;
  height: auto;
}

#UserInfo .user-info-doc-upload .col-12.p-3.text-center.font-weight-bold {
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  padding: 0 !important;
  font-size: 0;
  line-height: 0;
  text-align: left;
}

#UserInfo .user-info-doc-upload .col-12.p-3.text-center.font-weight-bold .fas {
  float: none !important;
  margin: 0 2px !important;
  font-size: 12px;
}

@media (min-width: 992px) {
  #UserInfo .user-info-docs-grid {
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }
}

@media (max-width: 767px) {
  #UserInfo .user-info-doc-upload {
    min-height: 68px;
    padding: 12px 14px;
  }

  #UserInfo .user-info-doc-upload__title {
    font-size: 13px;
  }
}

#UserInfo .user-info-bank-form {
  align-items: end;
}

#UserInfo .user-info-bank-form .user-info-identity-field--md {
  grid-column: span 2;
}

#UserInfo .user-info-bank-form .form-control[dir="ltr"] {
  text-align: left;
}

#UserInfo .user-info-bank-form select.form-control {
  appearance: none;
  -webkit-appearance: none;
  background-image: linear-gradient(45deg, transparent 50%, #6b7b8e 50%),
    linear-gradient(135deg, #6b7b8e 50%, transparent 50%);
  background-position: calc(100% - 16px) calc(50% - 3px),
    calc(100% - 11px) calc(50% - 3px);
  background-size: 5px 5px, 5px 5px;
  background-repeat: no-repeat;
  padding-left: 2rem;
}

#UserInfo .user-info-sheba-input {
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: 40px;
  overflow: hidden;
  direction: ltr;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(41, 52, 95, 0.06);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

#UserInfo .user-info-sheba-input:focus-within {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
}

#UserInfo .user-info-sheba-prefix {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  padding: 0 0.7rem;
  color: #287db4;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 800;
  background: #edf5fb;
}

#UserInfo .user-info-sheba-input .form-control {
  flex: 1 1 auto;
  min-width: 0;
  height: 40px;
  min-height: 40px;
  border: none !important;
  border-radius: 0 !important;
  background: transparent;
  box-shadow: none !important;
}

#UserInfo .user-info-sheba-input .form-control:focus {
  outline: none;
  box-shadow: none !important;
}

#UserInfo .user-info-bank-status {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
  min-height: 40px;
  padding: 0.4rem 0.75rem;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(41, 52, 95, 0.06);
}

#UserInfo .user-info-bank-status__state {
  min-width: 52px;
  font-size: 12px;
  font-weight: 700;
  text-align: center;
}

#UserInfo .user-info-bank-status__state.is-on {
  color: #068997;
}

#UserInfo .user-info-bank-status__state.is-off {
  color: #8b98a8;
}

#UserInfo .user-info-bank-switch {
  position: relative;
  display: inline-flex;
  margin: 0;
  cursor: pointer;
}

#UserInfo .user-info-bank-switch input {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: 0;
  opacity: 0;
}

#UserInfo .user-info-bank-switch__track {
  position: relative;
  display: block;
  width: 44px;
  height: 26px;
  border-radius: 999px;
  background: #d5dee6;
  transition: background 180ms ease;
}

#UserInfo .user-info-bank-switch__track::after {
  content: "";
  position: absolute;
  top: 3px;
  right: 3px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(19, 36, 58, 0.22);
  transition: transform 180ms ease;
}

#UserInfo .user-info-bank-switch input:checked + .user-info-bank-switch__track {
  background: linear-gradient(110deg, #29345f, #05b8c8);
}

#UserInfo
  .user-info-bank-switch
  input:checked
  + .user-info-bank-switch__track::after {
  transform: translateX(-18px);
}

#UserInfo
  .user-info-bank-switch
  input:focus-visible
  + .user-info-bank-switch__track {
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.22);
}

#UserInfo .user-info-bank-add {
  --bnp-brand-navy: #29345f;
  --bnp-brand-indigo: #56508d;
  --bnp-brand-purple: #8d58a4;
  --bnp-border-default: #dbe5eb;
  --bnp-focus-ring: 0 0 0 4px rgba(5, 184, 200, 0.2);
  --bnp-shadow-md: 0 12px 24px rgba(41, 52, 95, 0.18);
  --bnp-motion-fast: 180ms;
  --bnp-ease-standard: cubic-bezier(0.165, 0.84, 0.44, 1);
  --sv-control-h: 40px;

  width: 100%;
  padding-top: 0.25rem;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
}

#UserInfo .user-info-bank-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  justify-content: flex-end;
  gap: 0.625rem;
  width: 100%;
  margin-top: 1rem;
  padding-top: 0.875rem;
  border-top: 1px solid #e8eef2;
  box-sizing: border-box;
}

#UserInfo .user-info-bank-actions__btn {
  flex: 1 1 calc(50% - 0.3125rem);
  min-width: 0;
  margin: 0;
}

@media (min-width: 576px) {
  #UserInfo .user-info-bank-actions {
    flex-wrap: nowrap;
    max-width: 360px;
    margin-inline-start: auto;
    margin-inline-end: 0;
  }

  #UserInfo .user-info-bank-actions__btn {
    flex: 1 1 0;
    min-width: 168px;
  }
}

@media (max-width: 575px) {
  #UserInfo .user-info-bank-actions {
    flex-direction: column;
  }

  #UserInfo .user-info-bank-actions__btn {
    flex: none;
    width: 100%;
  }
}

html.user-info-estelam-html,
body.user-info-estelam-html,
body.user-info-estelam-html #app,
html.user-info-estelam-html body,
#UserInfo.user-info-estelam {
  background: #f5f7fb !important;
  background-color: #f5f7fb !important;
  background-image: none !important;
}
</style>
<style scoped>
.btn-submit {
  color: blanchedalmond !important;
  background: linear-gradient(
    301deg,
    rgba(145, 124, 193, 1) 0%,
    rgba(72, 20, 193, 1) 100%
  );
  /* background: linear-gradient(301deg, rgba(145, 124, 193, 1) 0%,#403c47 100%); */
}

.btn-submit:hover {
  color: blueviolet !important;
  background: #f8f9fa;
  border: solid 3px rgba(72, 20, 193, 1);
}
</style>
